// src/contexts/AuthContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { http } from '../api/http';

const defaultAuth = {
  user: null,
  isLoggedIn: false,
  loading: true,
  login: async () => {},
  logout: () => {},
  refresh: async () => null,
};

const AuthCtx = createContext(defaultAuth);

export function AuthProvider({ children }) {
  const [mounted, setMounted] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 1) On attend le montage client -> évite le mismatch SSR
  useEffect(() => {
    setMounted(true);
  }, []);

  // 2) On charge /api/me uniquement si un token existe
  useEffect(() => {
    if (!mounted) return;
    const token = localStorage.getItem('token_b2b');
    if (!token) {
      setLoading(false);
      return;
    } // pas connecté -> pas d'appel API

    http
      .get('/me')
      .then((res) => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, [mounted]);

  const login = async (token) => {
    localStorage.setItem('token_b2b', token);
    const { data } = await http.get('/me'); // intercepteur ajoutera le header
    console.log('%csrccontextsAuthContext.tsx:39 data', 'color: #007acc;', data);
    setUser(data);
    console.log('%csrccontextsAuthContext.tsx:41 user', 'color: #007acc;', user);
  };

  const logout = () => {
    localStorage.removeItem('token_b2b');
    localStorage.removeItem('userProfil');
    try {
      sessionStorage.clear();
    } catch {}
    setUser(null);
  };

  const refresh = async () => {
    const { data } = await http.get('/me');
    setUser(data);
    return data;
  };

  const value = { user, isLoggedIn: !!user, loading, login, logout, refresh };

  // 👇 clé : tant que le client n'est pas monté, on ne rend rien
  if (!mounted) return null;

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}
